import cruxAxios from '../../../app/cruxAxios'

/**
 * @file CRUX BIZGATEWAY API
 * @see https://crux-bizgateway-private-sandbox.devel.kakao.com/apidoc/?upstream=keywordad-api&type=PUBLIC&group=tracker-api#/%EA%B2%8C%EC%9D%B4%ED%8A%B8%EC%9B%A8%EC%9D%B4%20%EC%9D%B8%EC%A6%9D
 */
const { post, get } = cruxAxios

export const loginDsp = () => post('/auth/login/dsp')
export const getDspAccount = () => get('/crux-account/dspAccount')
export const loginOtp = ({ otp, accountId, adAccountId }) =>
  post('/auth/login/otp', {
    otp,
    observerId: accountId,
    targetId: adAccountId,
    targetServiceType: 'AD_ACCOUNT',
    observerServiceType: 'ADMIN',
  })
